/**
 * The Refine `meta.fields` selection for one behavior experiment as the E-era portal reads it: the
 * legacy row (every shipped list keeps working — plan 04 D3) PLUS the additive fields the inline
 * back-projection writes (handoff §4). Shared by the editor, the view and every command payload, so
 * the page state after a command is the same shape as the page state after a load.
 */
export const BEHAVIOR_EXPERIMENT_SETTINGS_FIELDS = [
  'experiment',
  'time',
  'place',
  'people',
  'resources',
  'survey',
];

export const BEHAVIOR_EXPERIMENT_OUTCOME_FIELDS = [
  'behaviors',
  { emotions: ['id', 'strength'] },
  'feelings',
  'patientReflections',
  'therapistReflections',
  'newLearnings',
  'meaningForOriginalBelief',
  'oldThoughtStrength',
  'newThought',
  'newThoughtStrength',
];

export const BEHAVIOR_EXPERIMENT_OBSERVATION_FIELDS = [
  'observationId',
  'occurredAt',
  'whatHappened',
  { emotions: ['id', 'strength'] },
  'feelings',
  'behaviors',
  'whichHypothesisHeld',
  'rating',
  'learnings',
];

export const BEHAVIOR_EXPERIMENT_ES_FIELDS = [
  '_id',
  'userId',
  'therapistId',
  'createdAt',
  'updatedAt',
  'purpose',
  'design',
  'hypothesisType',
  'hypothesisA',
  'hypothesisAStrength',
  'hypothesisAConfirmationCriteria',
  'hypothesisB',
  'hypothesisBStrength',
  'hypothesisBConfirmationCriteria',
  'type',
  'activeSubtype',
  'observationalSubtype',
  { settings: BEHAVIOR_EXPERIMENT_SETTINGS_FIELDS },
  {
    prediction: [
      { emotions: ['id', 'strength'] },
      'feelings',
      'behaviors',
      'otherPredictions',
    ],
  },
  'safetyBehaviors',
  'helpfulCopingStrategies',
  'followUpExperimentsIdeas',
  { outcome: BEHAVIOR_EXPERIMENT_OUTCOME_FIELDS },
  // ── E02 additive read fields ──
  'experimentId',
  'status',
  'activatedAt',
  'completedAt',
  { observations: BEHAVIOR_EXPERIMENT_OBSERVATION_FIELDS },
];
